import axios from 'axios';

// ======================== Configuration ========================
const BASE_URL = 'https://loyalty.bom.asia';

// ======================== Refresh Token Functions ========================

/**
 * Check và refresh token
 */
export const checkRefreshToken = async (accessToken, refreshToken) => {
  try {
    
    const response = await axios.post(`${BASE_URL}/api/check-token`, {
      accessToken,
      refreshToken,
    });

    
    // Lưu token mới nếu có
    if (response.data.accessToken) {
      localStorage.setItem('authToken', response.data.accessToken);
    }
    if (response.data.refreshToken) {
      localStorage.setItem('refresh_token', response.data.refreshToken);
    }
    
    return response.data;
  } catch (error) {
    console.error('Lỗi khi làm mới token:', error);
    throw error.response?.data || { message: 'Không thể làm mới token' };
  }
};

// ======================== Default Export ========================
export default {
  checkRefreshToken,
};

